<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.periodo' | translate"
    [array]="aniosDisponibles" [typeFilter]="Filters.YEAR"
    [click]="false"
    (eventClick)="yearChange($event)"
  />
  <app-filters filtros
    [name]="'filtros.lider' | translate"
    [array]="responsables2" [typeFilter]="Filters.SUCURSALES"
    [click]="false" [consolidado]="selecAll"
    (eventClick)="cambioLider($event)"
  />
  <app-filters filtros
    [name]="'filtros.res' | translate"
    [array]="responsablesAct" [typeFilter]="Filters.SUCURSALES"
    [click]="false" [consolidado]="selecAllAct"
    (eventClick)="cambioLiderAct($event)"
  />

  <div borrador [ngStyle]="{'color':'gray'}"
    (click)="borrarFiltro()" class="iconoMen" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
      <img src="./../../../../assets/img/eraser.png">
  </div>

  <div contenido class="contenidoClass" [ngClass]="{'w3-disabled cursordesactivado': desactivado}">
    <div class="w3-row zonaSelects">
      <div class="w3-row">
        <div class="w3-half" style="margin-right: 4vh;">
          <div class="texto">
            <div class="w3-right zonaTexto2">
              <span class="w3-right textoInputs"> {{'gestion.formulacion.proy-estra.campo1' | translate}}</span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="zonaInput">
              <select class="contentSelect" (change)="cambioPer()" [(ngModel)]="perSelect" [ngClass]="{'placeholderSelect': perSelect === ''}">
                <option value="" disabled hidden selected> {{'gestion.formulacion.proy-estra.campo1TT' | translate}} </option>
                @for (opt of perspectivas; track $index) {
                  <option value="{{opt.id}}" matTooltip="{{opt.nombre}}"> {{opt.nombre}} </option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="w3-row" style="padding-top: 1vh;">
        <div [ngClass]="perSelect?'':'w3-disabled'" class="w3-half">
          <div class="texto">
            <div class="w3-right zonaTexto2">
              <span class="w3-right textoInputs"> {{'gestion.formulacion.proy-estra.campo2' | translate}}</span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="zonaInput">
              <select class="contentSelect" (change)="cambioObj()"[(ngModel)]="objSelect" [ngClass]="{'placeholderSelect': objSelect === ''}">
                <option value="" disabled hidden selected> {{'gestion.formulacion.proy-estra.campo2TT' | translate}} </option>
                @for (opt of objetivos; track $index) {
                  @if(perSelect === opt.perspectiveId){
                    <option value="{{opt.id}}"  matTooltip="{{opt.nombre}}"> {{opt.nombre}} </option>
                  }                      
                }
              </select>
            </div>
          </div>
        </div>
        <div [ngClass]="objSelect?'':'w3-disabled'" class="w3-rest">
          <div class="texto" style="width: fit-content!important;">
            <div class="w3-right zonaTexto2">
              <span class="w3-right textoInputs"> {{'gestion.formulacion.proy-estra.campo3' | translate}}</span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="zonaInput">
              <select class="contentSelect" (change)="cambioEstra()" [(ngModel)]="estSelect" [ngClass]="{'placeholderSelect': estSelect === ''}">
                <option value="" disabled hidden selected> {{'gestion.formulacion.proy-estra.campo3TT' | translate}} </option>
                @for (opt of estrategias; track $index) {
                  @if(programa_pertenece(objSelect,opt)){
                    <option value="{{opt.id}}" matTooltip="{{opt.name}}"> {{opt.name}} </option>
                  }                      
                }
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="zonaGantt">
      <app-contenedor-elementos [header]="{title: ''}">
        <div iconos *appRoles="permisos.CARGA_ARCHIVOS" class="colorBotonDeNuevo" (click)="openModalProy()">
          <mat-icon #add class="iconoMen" matTooltip="{{'gestion.formulacion.proy-estra.agregarProy' | translate}}">add_circle_outline</mat-icon> 
          <label for="add">{{'gestion.formulacion.proy-estra.agregarProy' | translate}}</label>
        </div>
        <div iconos>
          <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menu2">more_vert</mat-icon>
        </div>
        <mat-menu #menu2="matMenu">
          <button (click)="exportar_excel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.Exportar' | translate}}</span>
          </button>
          <button (click)="validarPro()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            {{'gestion.formulacion.proy-estra.optmenuValidarPonderacion' | translate}}
          </button>
          <button (click)="ponderacionAutomatica()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            {{'gestion.formulacion.proy-estra.optmenuPondAuto' | translate}}
          </button>
        </mat-menu>

        <div body class="tabla">
          @if(!mostabla){
            <app-skeleton-table/>
          }@else {
            <table class="tabla-aleema">
              <thead>
                <tr>
                  <th style="line-height: 1.2;">
                    @if (expandirProg) {
                      <mat-icon class="iconoMen w3-button" matTooltip="{{'gestion.formulacion.proy-estra.tooltipOcultarAll' | translate}}" matTooltipPosition="left" (click)="mosOculAll()">expand_less</mat-icon>
                    }@else {
                      <mat-icon class="iconoMen w3-button" matTooltip="{{'gestion.formulacion.proy-estra.tooltipMostrarAll' | translate}}" matTooltipPosition="left" (click)="mosOculAll()">expand_more</mat-icon>
                    }
                  </th>
                  <th (click)="ordenamientoTabla()" style="line-height: 1.2; width: 20vw; cursor: pointer;">
                    {{'gestion.formulacion.proy-estra.titTab1' | translate}}
                    @switch (ordenamiento) {
                      @case ('id') {<mat-icon class="iconoSortIni">sort_by_alpha</mat-icon>} 
                      @case ('asc') {<mat-icon class="iconoSortIni">vertical_align_bottom</mat-icon>} 
                      @case ('des') {<mat-icon class="iconoSortIni">vertical_align_top</mat-icon>} 
                    }
                  </th>
                  <th style="width: 16vw; line-height: 1.2;">{{'gestion.formulacion.proy-estra.titTab2' | translate}}</th>
                  @if (objSelect !== '') {
                    <th> {{'gestion.formulacion.proy-estra.titTab3' | translate}} </th>
                  }                    
                  <th> {{'gestion.formulacion.proy-estra.titTab4' | translate}} </th>
                  <th> {{'gestion.formulacion.proy-estra.titTab5' | translate}} </th>
                  <th style="line-height: 1.2;"> {{'gestion.formulacion.proy-estra.titTab6' | translate}} </th>
                  <th class="th-gantt">
                    <div class="gantt-ruler">
                      @for (mes of meses; track $index) {
                        <div class="gantt-mes-label" [style.width]="getMesWidth(mes)">{{mes.name}}</div>
                      }
                    </div>
                  </th>
                  @if (diccionarioAdicionales.length !== 0) {
                    @for (ad of diccionarioAdicionales; track ad; let i = $index) {
                      <th [matMenuTriggerFor]="manuEdicionAd"
                        style="padding: 0vw 0.5vw; line-height: 1.2; cursor: pointer;">
                        {{ad.name}}
                      </th>
                      <mat-menu class="w3-medium" #manuEdicionAd="matMenu">
                        <button (click)="editarAdicional(ad)" class="mat-menu-item" mat-menu-item>
                          <mat-icon [ngStyle]="{'color':'gray'}">edit</mat-icon>
                          {{'menu.Editar' | translate}}
                        </button>
                        <button (click)="eliminarAdicional(ad)" class="mat-menu-item" mat-menu-item> 
                          <mat-icon [ngStyle]="{'color':'gray'}">delete</mat-icon>
                          {{'menu.eliminar' | translate}} 
                        </button>
                      </mat-menu>
                    }
                  }
                  <th *appRoles="permisos.CARGA_ARCHIVOS"> 
                    <button matTooltip="{{'gestion.formulacion.proy-estra.agregarAdicional' | translate}}" class="colorBotonDeNuevo">
                      <mat-icon class="iconoMen" (click)="agregarAdicional()">add_circle_outline</mat-icon>
                    </button>
                  </th>
                </tr>
              </thead>
              @for (pro of proyectos; track pro; let i = $index) {
                <tbody>
                  <tr style="font-weight: bold;">
                    <td>
                      @if (pro.check) {
                        <mat-icon class="iconoMen" matTooltip="{{'gestion.formulacion.proy-estra.tooltipOcultar' | translate}}" 
                        matTooltipPosition="left" (click)="mosOcul(i)">expand_less</mat-icon>
                      }@else {
                        <mat-icon class="iconoMen" matTooltip="{{'gestion.formulacion.proy-estra.tooltipMostrar' | translate}}"
                        matTooltipPosition="left" (click)="mosOcul(i)">expand_more</mat-icon>
                      }
                      <mat-icon *appRoles="permisos.CARGA_ARCHIVOS" (click)="agragarActividades(pro.id)" class="iconoMen colorBotonDeNuevo">add_circle_outline</mat-icon> 
                      <mat-icon *appRoles="permisos.CARGA_ARCHIVOS" class="iconoMen" (click)="editarPro(pro)">edit</mat-icon>
                      <mat-icon *appRoles="permisos.CARGA_ARCHIVOS" class="iconoMen" (click)="alertas('eliminarPro',pro)">delete</mat-icon>
                    </td>
                    <td style="width: 20vw!important;"
                    [matTooltip]="pro.nombre" [appOverflowTooltip]="pro.nombre">
                      {{pro.nombre}}
                    </td>
                    <td [matTooltip]="obtres(pro.responsibleId)" [appOverflowTooltip]="obtres(pro.responsibleId)" style="min-width: 5vw; max-width: 20vw; line-height: 1.2;">
                      {{obtres(pro.responsibleId)}}
                    </td>
                    @if (objSelect !== '') {
                      @if (pro.actividades.length !== 0) {
                        <td *appRoles="permisos.CARGA_ARCHIVOS" style="min-width: 5vw; max-width: 20vw; cursor: pointer; line-height: 1.2;"
                        (dblclick)="edicionPond(pro)" matTooltip="{{'menu.Editar' | translate}}">
                          {{escribirPond(pro)!==null?formatearnormalDec(escribirPond(pro)):0}}
                        </td>
                        <td *appRolesNeg="permisos.CARGA_ARCHIVOS" class="w3-center" 
                        style="min-width: 5vw; max-width: 20vw; line-height: 1.2;">
                          {{escribirPond(pro)!==null?formatearnormalDec(escribirPond(pro)):0}}
                        </td>
                      }@else {
                        <td style="min-width: 5vw; max-width: 20vw; cursor: pointer; line-height: 1.2;"><br></td>
                      }                        
                    }
                    <td class="w3-center" style="min-width: 5vw; max-width: 20vw; line-height: 1.2;">
                      {{obtFecha(pro.fecha_ini)}}
                    </td>
                    <td class="w3-center" style="min-width: 5vw; max-width: 20vw; line-height: 1.2;">
                      {{obtDias(pro.fecha_ini,pro.fecha_fin)}}
                    </td>
                    <td class="w3-center" style="min-width: 5vw; max-width: 20vw; line-height: 1.2;">
                      {{obtFecha(pro.fecha_fin)}}
                    </td>
                    <td class="td-gantt">
                      <div class="gantt-track">
                        <div class="gantt-grid-lines"></div>
                        <div [ngClass]="'gantt-bar gantt-bar-plan-'+(i % 4)"
                          [style.left]="getBarLeft(pro.fecha_ini)"
                          [style.width]="getBarWidth(pro.fecha_ini, pro.fecha_fin)">
                        </div>
                      </div>
                    </td>
                    @if (diccionarioAdicionales.length !== 0) {
                      @for (ad of diccionarioAdicionales; track ad; let j = $index) {
                        <td class="w3-center" style="min-width: 5vw; max-width: 20vw; line-height: 1.2;">
                          @if (edicionPro(i,j,pro)) {
                            <div style="min-width: 3vw; max-width: 10vw;">
                              {{imprimirPro(pro,j)}} 
                            </div>
                          }@else{
                            <div style="min-width: 3vw; max-width: 10vw;"><br></div>
                          }
                        </td>
                      }
                    }
                    <td *appRoles="permisos.CARGA_ARCHIVOS">  </td>
                  </tr>
                  @for (act of pro.actividades; track $index) {
                    @if (pro.check && responsableActOfAct(act) && mostrarAct(act)) {
                      <tr>
                        <td *appRoles="permisos.CARGA_ARCHIVOS"style="margin-left: 2vh; min-width: 3vw; max-width: 20vw;">
                          <mat-icon class="iconoMen" (click)="editActiv(act,pro.id)">edit</mat-icon>
                          <mat-icon class="iconoMen" (click)="alertas('eliminar',act)">delete</mat-icon>
                        </td>
                        <td *appRolesNeg="permisos.CARGA_ARCHIVOS"> <br> </td>
                        <td style="margin-left: 2vh; min-width: 5vw; max-width: 20vw;" 
                        [matTooltip]="act.nombre" [appOverflowTooltip]="act.nombre">
                          {{act.nombre}}
                        </td>
                        <td style="margin-left: 2vh; min-width: 5vw; max-width: 20vw;"
                        [matTooltip]="obtres(pro.responsibleId)" [appOverflowTooltip]="obtres(act.responsableId)">
                          {{obtres(act.responsableId)}}
                        </td>
                        @if(objSelect !== ''){
                          <td style="margin-left: 2vh; min-width: 5vw; max-width: 20vw;"> <br> </td>
                        }
                        <td class="w3-center" style="margin-left: 2vh; min-width: 5vw; max-width: 20vw;">
                          <span>{{act.fecha_inicio.format('DD-MM-YYYY')}}</span>
                        </td>
                        <td class="w3-center" style="margin-left: 2vh; min-width: 5vw; max-width: 20vw;">
                          <span>{{obtDias(act.fecha_inicio,act.fecha_fin)}}</span>
                        </td>
                        <td class="w3-center" style="margin-left: 2vh; min-width: 5vw; max-width: 20vw;">
                          <span>{{act.fecha_fin.format('DD-MM-YYYY')}}</span>
                        </td>
                        <td class="td-gantt">
                          <div class="gantt-track">
                            <div class="gantt-grid-lines"></div>
                            <div [ngClass]="'gantt-bar gantt-bar-act-'+(i % 4)"
                              [style.left]="getBarLeft(act.fecha_inicio)"
                              [style.width]="getBarWidth(act.fecha_inicio, act.fecha_fin)">
                            </div>
                          </div>
                        </td>
                        @if (diccionarioAdicionales.length !== 0) {
                          @for (ad of diccionarioAdicionales; track ad; let j = $index) {
                            <td style=" min-width: 5vw; max-width: 20vw;">
                              <ng-container *appRoles="permisos.CARGA_ARCHIVOS">
                                @if (edicion(j,act)) {
                                  <div class="w3-center" style="cursor: pointer;" matTooltip="{{'menu.Editar' | translate}}" (dblclick)="editar(act,j)"> {{imprimir(act,j)}} <br> </div>
                                }                                  
                              </ng-container>
                              <ng-container  *appRolesNeg="permisos.CARGA_ARCHIVOS">
                                @if (edicion(j,act)) {
                                  <div class="w3-center"> {{imprimir(act,j)}} </div>
                                }                                  
                              </ng-container>
                              @if (!edicion(j,act)) {
                                <div> {{imprimir(act,j)}} </div>
                              }
                            </td>
                          }
                        }
                        <td *appRoles="permisos.CARGA_ARCHIVOS">  </td>
                      </tr>
                    }
                  }
                </tbody>
              }
            </table>
          }
        </div>
      </app-contenedor-elementos>
    </div>
  </div>
</app-esqueleto-tableros>

<!-- Modal para agregar y editar proyectos -->
<app-modal [isOpen]="modal1" [cerrar]="false" (close)="closeModal()">
  <div modal-header>
    {{titModal}}
  </div>

  <div modal-body>
    <div class="w3-row" style="width: 95%; margin: 1vh;" [formGroup]="formPro">     
        <div style="margin-top: 1vh !important;">
          <div class="texto">
            <div class="w3-right zonaTexto2">
              <span class="w3-right textoInputs"> {{'gestion.formulacion.proy-estra.campoProyecto' | translate}} *</span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="zonaInput">
              <input type="text" class="contentInput" formControlName="inputNamePro" placeholder="{{'gestion.formulacion.proy-estra.campoProyectoTT' | translate}}"
              [matTooltip]="formPro.controls.inputNamePro.value" [appOverflowTooltip]="formPro.controls.inputNamePro.value">
            </div>
          </div>
        </div>
        <div style="margin-top: 1vh !important;">
          <div class="texto">
            <div class="w3-right zonaTexto2">
              <span class="w3-right textoInputs"> {{'gestion.formulacion.proy-estra.campoDesc' | translate}}</span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="zonaInput" style="height: fit-content;">
              <textarea class="contentTextArea" formControlName="inputDescripcion" rows="3"
              placeholder="{{'gestion.formulacion.proy-estra.campoDescTT' | translate}}"
              [matTooltip]="formPro.controls.inputDescripcion.value" [appOverflowTooltip]="formPro.controls.inputDescripcion.value"></textarea>
            </div>
          </div>
        </div>
        <div style="margin-top: 1vh !important;">
          <div class="texto">
            <div class="w3-right zonaTexto2">
              <span class="w3-right textoInputs"> {{'gestion.formulacion.proy-estra.campoEstra' | translate}}</span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="zonaInput">
              <select class="contentSelect" formControlName="inputEstrategia" value="" [ngClass]="{'placeholderSelect': formPro.controls['inputEstrategia'].value === ''}">
                <option value="" disabled hidden selected style="color: #b6b6b6 !important;"> {{'gestion.formulacion.proy-estra.campoEstraTT' | translate}} </option>
                @for (opt of estrategias; track $index) {
                  <option class="textoOverFlow" value="{{opt.id}}"
                  [matTooltip]="opt.name" [appOverflowTooltip]="opt.name">{{opt.name}}</option>
                }                  
              </select>
            </div>
          </div>
        </div>
        <div style="margin-top: 1vh !important;">
          <div class="texto">
            <div class="w3-right zonaTexto2">
              <span class="w3-right textoInputs"> {{'gestion.formulacion.proy-estra.campoObj' | translate}} *</span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="zonaInput">
              <select class="contentSelect" formControlName="inputObjetivo" value="" [ngClass]="{'placeholderSelect': formPro.controls['inputObjetivo'].value === ''}">
                <option value="" disabled hidden selected style="color: #b6b6b6 !important;"> {{'gestion.formulacion.proy-estra.campoObjTT' | translate}} </option>
                @for (opt of objetivos; track $index) {
                  @if(existeEstrategia(opt)){
                    <option class="textoOverFlow" value="{{opt.id}}">{{opt.nombre}}</option>
                  }
                }                  
              </select>
            </div>
          </div>
        </div>
        <div style="margin-top: 1vh !important;">
          <div class="texto">
            <div class="w3-right zonaTexto2">
              <span class="w3-right textoInputs"> {{'gestion.formulacion.proy-estra.campoLider' | translate}} *</span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="zonaInput">
              <select class="contentSelect" formControlName="inputLider" value="" [ngClass]="{'placeholderSelect': formPro.controls['inputLider'].value === ''}">
                <option value="" disabled hidden selected style="color: #b6b6b6 !important;"> {{'gestion.formulacion.proy-estra.campoLiderTT' | translate}} </option>
                @for (opt of responsables; track $index) {
                  <option class="textoOverFlow" value="{{opt.id}}">{{opt.nombre}}</option>
                }                  
              </select>
            </div>
          </div>
        </div>
      </div>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="closeModal()"
  />
  <app-button modal-footer
    [ngClass]="{'w3-disabled':formPro.invalid}"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="guardarPro(accionModal)"
  />
</app-modal>
<!-- Modal para agregar y editar actividades -->
<app-modal [isOpen]="modal2" [cerrar]="false" (close)="closeModal()">
  <div modal-header>
    {{titModal}}
  </div>

  <div modal-body>
    <div class="w3-row" style="width: 95%; margin: 1vh;" [formGroup]="formAct">
      <div class="inputDisp">
        <div class="form-group">
          <label for="nombreedit" class="form-label"> {{'gestion.formulacion.proy-estra.campoAct' | translate}} <span>*</span> </label>
          <div style="display: inline-block; width: 100%;">
            <input type="text" class="contentInput" style="min-width: 18vw;" formControlName="inputNameAct" placeholder="{{'gestion.formulacion.proy-estra.campoActTT' | translate}}"
            [matTooltip]="formAct.controls.inputNameAct.value" [appOverflowTooltip]="formAct.controls.inputNameAct.value">          
          </div>
        </div>
      </div>
      <div class="inputDisp">
        <div class="form-group">
          <label for="nombreedit" class="form-label"> {{'gestion.formulacion.proy-estra.campoFecIni' | translate}} <span>*</span> </label>
          <div style="display: inline-block; width: 100%;">
            <input type="date" class="contentDate" style="min-width: 18vw;" formControlName="inputFechaIn" value="{{fechaAct}}" min="{{minDate}}" max="{{maxDate}}"
            placeholder="{{'gestion.formulacion.ind-metas.campoFecIniTT' | translate}}">
          </div>
        </div>
      </div>
      <div class="inputDisp">
        <div class="form-group">
          <label for="nombreedit" class="form-label"> {{'gestion.formulacion.proy-estra.campoFecFin' | translate}} <span>*</span> </label>
          <div style="display: inline-block; width: 100%;">
            <input type="date" class="contentDate" style="min-width: 18vw;"
              formControlName="inputFechaFn"
              value="{{fechaAct}}"
              min="{{this.formAct.controls['inputFechaIn'].value}}"
              max="{{maxDate}}"
            placeholder="{{'gestion.formulacion.ind-metas.campoFecIniTT' | translate}}">
          </div>
        </div>
      </div>
      <div class="inputDisp">
        <div class="form-group">
          <label for="responsable" class="form-label">
              {{'gestion.formulacion.proy-estra.campoResp' | translate}} *
          </label>
          <select class="contentSelect" formControlName="inputLider" value="default" [ngClass]="{'placeholderSelect': formAct.controls['inputLider'].value === ''}" style="min-width: 18vw !important;">
              <option value="" disabled hidden selected style="color: #b6b6b6 !important;"> {{'gestion.formulacion.proy-estra.campoRespTT' | translate}} </option>
              @for (opt of responsables; track $index) {
                <option class="textoOverFlow" value="{{opt.id}}"
                [matTooltip]="opt.nombre" [appOverflowTooltip]="opt.nombre">
                >{{opt.nombre}}</option>
              }                  
            </select>
        </div>
      </div>
    </div>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="closeModal()"
  />
  <app-button modal-footer
    [ngClass]="{'w3-disabled':formAct.invalid}"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="guardarAct(accionModal)"
  />
</app-modal>
<!-- Modal para agregar adicional -->
 <app-modal [isOpen]="modal3" [cerrar]="false" (close)="closeModal()">
  <div modal-header>
    {{titModal}}
  </div>

  <div modal-body>
    <div class="w3-row" [formGroup]="formAdi">
      <div class="inputDisp">
        @if (nombreDuplicidadAdi()) {
          <mat-error class="error-message">
            {{'gestion.formulacion.perspectivas.formText1'|translate}} <strong> {{'gestion.formulacion.perspectivas.formText2'|translate}}.</strong>
          </mat-error>
        }
        <div class="form-group">
          <label for="nombreedit" class="form-label"> {{'gestion.formulacion.proy-estra.campoAdicional' | translate}} <span>*</span> </label>
          <div style="display: inline-block; width: 100%;">
            <input type="text" class="contentInput" style="min-width: 18vw;" formControlName="inputNameAdi"
            placeholder="{{'gestion.formulacion.proy-estra.campoAdicionalTT' | translate}}"
            [matTooltip]="formAdi.controls.inputNameAdi.value" [appOverflowTooltip]="formAdi.controls.inputNameAdi.value">          
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="responsable" class="form-label">
            {{'gestion.formulacion.proy-estra.campoTipoAdicional' | translate}} *
        </label>
        <select id="responsable" formControlName="inputNameAdiEdit" value="default" [ngClass]="{'placeholderSelect': formAdi.controls['inputNameAdiEdit'].value === ''}"
          class="contentSelect" required style="min-width: 18vw;">
          <option value="" disabled selected>
              {{'gestion.formulacion.objetivos.formText5'|translate}}
          </option>
          <option value="texto" matTooltip="{{'gestion.formulacion.proy-estra.tipoTextoTT' | translate}}"> {{'gestion.formulacion.proy-estra.tipoTexto' | translate}} </option>
          <option value="moneda" matTooltip="{{'gestion.formulacion.proy-estra.tipoMonedaTT' | translate}}"> {{'gestion.formulacion.proy-estra.tipoMoneda' | translate}} </option>
          <option value="archivo" matTooltip="{{'gestion.formulacion.proy-estra.tipoArchTT' | translate}}"> {{'gestion.formulacion.proy-estra.tipoArch' | translate}} </option>
          <option value="numero" matTooltip="{{'gestion.formulacion.proy-estra.tipoTextoFijoTT' | translate}}"> {{'gestion.formulacion.proy-estra.tipoTextoFijo' | translate}} </option>
        </select>
      </div>
    </div>
  </div>
  
  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="closeModal()"
  />
  <app-button modal-footer
    [ngClass]="{'w3-disabled': formAdi.invalid || nombreDuplicidadAdi()}"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="guardarAdi()"
  />
 </app-modal>